import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddToFavoritesBtn from '../AddToFavoritesBtn';
import ModalAudioOptions from './components/ModalAudioOptions';

import './style.scss';

import { ReactComponent as More } from '../../assets/icons/more.svg';
import { ReactComponent as PlayPauseIcon } from '../../assets/icons/play-pause.svg';
import Share from '../Share';
import Loader from '../Loader';

const AudioSocialOptions = ({
  className,
  children,
  isPlaying,
  favorite,
  share,
  onClickFavorite,
  onPlay,
  isLoading
}) => {
  const [showModalprogram, setShowModalProgram] = useState(false);

  return (
    <div className={`AudioOptions ${className}`}>
      <button
        type="button"
        className="AudioOptions_toggle"
        onClick={() => setShowModalProgram(true)}
      >
        <More className="button-more" />
      </button>
      <Share {...share} dinamic />
      <AddToFavoritesBtn
        className="add-favorites ml-20"
        isFavorite={favorite}
        onClick={() => onClickFavorite()}
      />
      <button
        className="mainPlayer_playButton ml-20"
        type="button"
        onClick={() => onPlay()}
        title={isPlaying ? 'Pausar' : 'Reproducir'}
      >
        {isLoading ? (
          <Loader />
        ) : (
          <PlayPauseIcon
            className={`${
              isPlaying
                ? `mainPlayer_playButton__play `
                : `mainPlayer_playButton__pause `
            }`}
          />
        )}
      </button>
      {showModalprogram && (
        <ModalAudioOptions
          favorite={favorite}
          share={share}
          onClose={() => setShowModalProgram(false)}
          onClickFavorite={onClickFavorite}
        >
          {children}
        </ModalAudioOptions>
      )}
    </div>
  );
};

AudioSocialOptions.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  favorite: PropTypes.bool,
  share: PropTypes.shape({
    shareTitle: PropTypes.string,
    link: PropTypes.string
  }),
  isPlaying: PropTypes.bool,
  onClickFavorite: PropTypes.func,
  onPlay: PropTypes.func,
  isLoading: PropTypes.bool
};

AudioSocialOptions.defaultProps = {
  className: '',
  children: null,
  favorite: false,
  share: null,
  isPlaying: false,
  onClickFavorite: null,
  onPlay: null,
  isLoading: false
};

export default AudioSocialOptions;
